import { Button, List, Popover } from "antd"
import { memo, useMemo } from "react"
import { EventMap, useEditorEventBusInstance } from "../../events/useEventBusInstance"

const menus = [
  { key: 'setting', label: 'Basic Setting'},
  { key: 'table', label: 'Insert Table' },
]

export const TemplateMenu = memo(() => {
  const eventBus = useEditorEventBusInstance()

  const onClick = (key: string) => {
    switch (key) {
      case 'setting': {
        eventBus.trigger(EventMap.template.openSettingPanel, {})
        return;
      }
      case 'table': {
        return;
      }
      default: {

      }
    }
  }

  const content = useMemo(() => {
    return <List
      size="small"
      style={{ width: 200 }}
      dataSource={menus}
      renderItem={(item) => (
        <List.Item key={item.key} style={{cursor: 'pointer'}} onClick={() => onClick(item.key)}>{item.label}</List.Item>
      )}
    />
  }, []);

  return <Popover placement="bottomLeft" arrow={false} content={content}>
    <Button type="text">Template</Button>
  </Popover>
})